import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Spinner } from "reactstrap";
import HoldersTab from "./Items/Account/HoldersTab";
import QuestionsTab from "./Items/Account/QuestionsTab";
import KYCTab from "./Items/Account/KYCTab";
import DocumentsTab from "./Items/Account/DocumentsTab";
import InvestmentProfileTab from "./Items/Account/InvestmentProfileTab";
import ProfileTab from "./Items/Account/ProfileTab";
import SignatureSetsTab from "./Items/Account/SignatureSetsTab";
import PersonalReferencesTab from "./Items/Account/PersonalReferencesTab";
import BankAccountsTab from "./Items/Account/BankAccountsTab";
import RelatedAccountsTab from "./Items/Account/RelatedAccountsTab";
import PersonProfileTab from "./Items/Person/ProfileTab";
import PersonDocumentsTab from "./Items/Person/DocumentsTab";
import ShareHolderTab from "./Items/Person/ShareHolderTab";
import PersonArchivesTab from "./Items/Person/ArchivesTab";
import BeneficiariesTab from "./Items/Account/BeneficiariesTab";
import PersonPhonesTab from "./Items/Person/PhonesTab";
import GroupsTab from "./Items/Account/GroupsTab";
import FiscalResidence from "./Items/Person/FiscalReference";
import LegalAddress from "./Items/Person/LegalAddress";
import PersonKYC from "./Items/Person/PersonKYC";
import PersonBankAccount from "./Items/Person/PersonBankAccount";
import Suitability from "./Items/Person/Suitability";
import ExtendedData from "./Items/Person/ExtendedData";
import InstructionsTab from "./Items/Account/InstructionsTab";

const getAccountType = {
  Holders: "Holders",
  Questions: "Questions",
  KYC: "KYC",
  Documents: "Documents",
  InvestmentProfile: "InvestmentProfile",
  Profile: "Profile",
  SignatureSets: "SignatureSets",
  References: "References",
  BankAccounts: "BankAccounts",
  RelatedAccounts: "RelatedAccounts",
  Beneficiaries: "Beneficiaries",
  Groups: "Groups",
  Instructions: "Instructions",
};

export const personChangeType = {
  Information: "Information",
  Documents: "Documents",
  ShareHolders: "ShareHolders",
  Phone: "Phone",
  FiscalResidence: "FiscalResidence",
  LegalAddress: "LegalAddress",
  KYC: "KYC",
  BankAccount: "BankAccount",
  Suitability: "Suitability",
  ExtendedData: "ExtendedData",
};

const Comparer = ({
  requestedModification,
  account,
  currencies,
  person,
  fetchFile,
}) => {
  if (!requestedModification || !(account || person)) return <Spinner />;

  const comparerSelector = (props) => {
    let res;
    switch (requestedModification.AccountChangeType) {
      case getAccountType.Holders:
        res = <HoldersTab {...props} />;
        break;
      case getAccountType.Beneficiaries:
        res = <BeneficiariesTab {...props} />;
        break;
      case getAccountType.Questions:
        res = <QuestionsTab {...props} />;
        break;
      case getAccountType.KYC:
        res = <KYCTab {...props} />;
        break;
      case getAccountType.Documents:
        res = <DocumentsTab {...props} />;
        break;
      case getAccountType.InvestmentProfile:
        res = <InvestmentProfileTab {...props} />;
        break;
      case getAccountType.Profile:
        res = <ProfileTab {...props} />;
        break;
      case getAccountType.SignatureSets:
        res = <SignatureSetsTab {...props} />;
        break;
      case getAccountType.References:
        res = <PersonalReferencesTab {...props} />;
        break;
      case getAccountType.RelatedAccounts:
        res = <RelatedAccountsTab {...props} />;
        break;
      case getAccountType.BankAccounts:
        res = <BankAccountsTab {...props} currencies={currencies} />;
        break;
      case getAccountType.Groups:
        res = <GroupsTab {...props} />;
      case getAccountType.Instructions:
        res = <InstructionsTab {...props} />;
      
        break;
      default:
        switch (requestedModification.PersonChangeType) {
          case personChangeType.Information:
            res = <PersonProfileTab {...props} />;
            break;
          case personChangeType.Documents:
            if (requestedModification.file) {
              res = <PersonArchivesTab {...props} />;
            } else {
              res = (
                <PersonDocumentsTab
                  {...props}
                  remove={requestedModification.delete}
                />
              );
            }
            break;
          case personChangeType.ShareHolders:
            res = (
              <ShareHolderTab {...props} edit={!requestedModification.delete} />
            );
            break;
          case personChangeType.Phone:
            res = (
              <PersonPhonesTab
                {...props}
                remove={requestedModification.delete}
              />
            );
            break;
          case personChangeType.LegalAddress:
            res = (
              <LegalAddress {...props} remove={requestedModification.delete} />
            );
            break;
          case personChangeType.FiscalResidence:
            res = (
              <FiscalResidence
                {...props}
                remove={requestedModification.delete}
              />
            );
            break;
          case personChangeType.KYC:
            res = (
              <PersonKYC {...props} remove={requestedModification.delete} />
            );
            break;
          case personChangeType.BankAccount:
            res = (
              <PersonBankAccount
                {...props}
                remove={requestedModification.delete}
                currencies={currencies}
              />
            );
            break;
          case personChangeType.Suitability:
            res = (
              <Suitability {...props} remove={requestedModification.delete} />
            );
            break;
          case personChangeType.ExtendedData:
            res = <ExtendedData {...props} />;
            break;
          default:
            res = <span>Invalid Input.</span>;
        }
        break;
    }
    return res;
  };

  return (
    <Row>
      <Col>
        {comparerSelector({
          changedAccount: requestedModification.Account,
          account,
          showChanges: false,
          person,
          changedPerson: requestedModification.Person,
        })}
      </Col>
    {requestedModification.PersonChangeType!=personChangeType.ExtendedData &&
    (
      <Col>
        {comparerSelector({
          changedAccount: requestedModification.Account,
          account,
          showChanges: true,
          person,
          changedPerson: requestedModification.Person,
          fetchFile,
        })}
      </Col>
    )}
    </Row>
  );
};

Comparer.propTypes = {
  requestedModification: PropTypes.object,
  account: PropTypes.object,
  currencies: PropTypes.array,
  person: PropTypes.object,
};

Comparer.defaultProps = {
  requestedModification: undefined,
  account: undefined,
  person: undefined,
  currencies: undefined,
};

export default Comparer;
